<template>
    <div class="basic">
      <p class="title font">基本信息</p>
      <div class="basicinformation">
        <div class="row"><span>设备状态:</span><p v-if="warningdetails.deve_state === 'Y'">在线</p><p v-if="warningdetails.deve_state === 'N'">掉线</p></div>
        <div class="row"><span>监测位置:</span><p>{{warningdetails.deve_option}}</p></div>
        <div class="row"><span>设备编号:</span><p>{{warningdetails.deve_code}}</p></div>
        <div class="row"><span>设备名称:</span><p>{{warningdetails.deve_name}}</p></div>
        <div class="row"><span>预警类型:</span>
        <p v-if="warningdetails.alarm_type === 0">蓝色预警</p>
        <p v-if="warningdetails.alarm_type === 1">黄色预警</p>
        <p v-if="warningdetails.alarm_type === 2">橙色预警</p>
        <p v-if="warningdetails.alarm_type === 3">红色预警</p>
        </div>
        <div class="row"><span>预警数值:</span><p>{{warningdetails.alarm_value}}</p></div>
        <div class="row"><span>预警时间:</span><p>{{warningdetails.alarm_time}}</p></div>
        <div class="row"><span>解除时间:</span><p>{{warningdetails.end_time}}</p></div>
        <div class="row"><span>当天天气:</span><p>{{warningdetails.weather}}</p></div>
        <div class="row"><span>预警内容:</span><div>{{warningdetails.alarm_content}}</div></div>
        <div class="row"><span>预警预案:</span><div>{{warningdetails.alarm_case}}</div></div>
      </div>
    </div>
</template>

<script>
export default {
  props: ['warningdetails'],
  data () {
    return {
      title: '预警处置',
      state: 3
    }
  },
  methods: {

  },
  created () {

  },
  mounted () {

  }
}
</script>
<style lang='scss' scoped>
  @import '../assets/stylesheets/flowinformation';
</style>
